import { isFunction } from '../../../../common/base';
import { findNodeByClass } from './util';
/* wegame登录框*/

var wegameFrame = {
  isReady: false,
  $frame: null,
  currentOpt: {},
  // 初始化事件等
  init: function init(callback) {
    var self = this;

    if (self.isReady) {
      isFunction(callback) && callback();
      return;
    } // tpl


    var tpl = '<div class="wegameLoginCover"></div>\
			<div class="wegameLoginContent">\
				<div class="wegameHeader">\
					<div class="wegameLoginIcon"></div>\
					<a class="wegameClose" href="javascript:void(0)">×</a>\
				</div>\
				<iframe class="wegameloginframe" frameborder="0" src=""></iframe>\
			</div>';
    self.$frame = document.createElement('div');
    self.$frame.classList.add('milo-wegameLogin');
    self.$frame.innerHTML = tpl;
    document.getElementsByTagName('body')[0].appendChild(self.$frame); // style
    // var style='<style type="text/css">.wegameloginframe{width:100%;height:600px;overflow:hidden;border:0px solid white}.wegameLogin{position:fixed;width:100%;height:100%;left:0px;top:0px}.wegameLoginCover{position:absolute;width:100%;height:100%;left:0px;top:0px;z-index:9999;background-color:white;opacity:0.7;filter:alpha(opacity=70)}.wegameLoginContent{width:800px;height:600px;background-color:#fff;overflow:hidden;position:absolute;left:50%;top:50%;z-index:10000;margin-left:-400px;margin-top:-300px;border:1px solid #bfbfbf;box-shadow:0 0 10px rgba(0,0,0,.3)}.wegameLoginContent>div{height:30px;width:100%;background-color:none;font-size:18px}.wegameLoginContent>div.wegameLoginTitle{width:100%;background-color:#0e0e0e}div.wegameLoginIcon{display:none}.wegameLoginTitle>div.wegameLoginIcon{display:block;float:left;width:239px;height:60px;background:url(https://api.rail.tgp.qq.com/web/oauth2.0/login/images/wegame-logo-m.png) no-repeat center;margin-left:10px}.wegameLoginContent>div span{color:white;display:inline-block;line-height:30px;padding:0px 5px}.wegameLoginContent>div a{float:right;line-height:30px;text-decoration:none;color:white;font-weight:bold;font-size:25px;width:30px;text-align:center;cursor:pointer}.wegameLoginContent>div a:hover{color:#f57272}.wegameLoginContent>div{position:absolute;z-index:100001;right:0px;width:30px;top:0px;height:60px;text-align:center}.wegameLoginContent>div a{line-height:55px;display:inline-block}</style>';
    // $(style).appendTo(document.getElementsByTagName("head")[0]);
    // 绑定事件

    var closBtn = findNodeByClass(self.$frame, 'wegameClose');
    closBtn.addEventListener('click', function () {
      self.close();
    });
    self.isReady = true;
    isFunction(callback) && callback(); // })
  },
  close: function close(isForce) {
    if (this.currentOpt.showParams.canClose || isForce) {
      this.$frame.style.display = 'none';
    }
  },
  show: function show(url, opt) {
    var self = this;
    self.currentOpt = opt;
    this.init(function () {
      var loginFrame = findNodeByClass(self.$frame, 'wegameloginframe');
      var cover = findNodeByClass(self.$frame, 'wegameLoginCover');
      var content = findNodeByClass(self.$frame, 'wegameLoginContent');
      loginFrame.setAttribute('src', url);
      /* showParams相关*/
      // zIndex

      var zIndex = Number(opt.showParams.zIndex) || 999;
      self.$frame.style.zIndex = zIndex;
      cover.style.zIndex = zIndex;
      content.style.zIndex = zIndex + 1; // 是否显示cover

      if (opt.showParams.needMask) {
        cover.style.display = 'block';
      } else {
        cover.style.display = 'none';
      } // 是否允许关闭[显示关闭按钮]


      var closBtn = findNodeByClass(self.$frame, 'wegameClose');

      if (!opt.showParams.canClose) {
        closBtn.style.display = 'none';
      } else {
        closBtn.style.display = 'block';
      }

      self.$frame.style.display = 'block';
    });
  },
  showTitle: function showTitle(isShow) {
    var self = this;
    var header = findNodeByClass(self.$frame, 'wegameHeader');

    if (isShow) {
      header.classList.add('wegameLoginTitle');
    } else {
      header.classList.remove('wegameLoginTitle');
    }
  }
};
export default wegameFrame;